import { useFormikContext } from 'formik';
import React from 'react';

import Table from 'App/components/Table';
import useFetchTherapyAssessments from '../hooks/useFetchTherapyAssessments';
import ActionsCell from './ActionsCell';
import CreatedByCell from './CreatedByCell';
import CreatedByFilter from './CreatedByFilter';
import MobileQuestionsCell from './MobileQuestionsCell';
import MobileQuestionsFilter from './MobileQuestionsFilter';
import NameCell from './NameCell';
import truthyFilter from './truthyFilter';

const columns = [
    {
        Header: 'Name',
        accessor: 'name',
        Cell: NameCell,
        sortType: 'basic',
    },
    {
        Header: 'Created By',
        accessor: 'companyId',
        Cell: CreatedByCell,
        Filter: CreatedByFilter,
        filter: truthyFilter,
    },
    {
        Header: 'Mobile-Enabled Questions',
        accessor: 'isMobile',
        Cell: MobileQuestionsCell,
        Filter: MobileQuestionsFilter,
        filter: truthyFilter,
        sortType: 'basic',
    },
    {
        Header: 'Actions',
        Cell: ActionsCell,
    },
];

const AssessmentManagerTable = () => {
    const {
        values: { category, isShowRetired },
    } = useFormikContext();
    const { data = [], isLoading } = useFetchTherapyAssessments(category?.id, isShowRetired);

    return (
        <div>
            <Table
                columns={columns}
                data={Object.values(data)}
                isLoading={isLoading}
                placeholderText={
                    !category
                        ? 'All assessments for the selected therapeutic category will appear here.'
                        : 'No assessments have been created.'
                }
                pageSizeOptions={[10, 25, 50]}
                initialState={{
                    sortBy: [
                        {
                            id: 'name',
                        },
                    ],
                }}
            />
        </div>
    );
};

export default AssessmentManagerTable;
